import { render, staticRenderFns } from "./Round.vue?vue&type=template&id=29c51522&scoped=true"
import script from "./Round.vue?vue&type=script&lang=js"
export * from "./Round.vue?vue&type=script&lang=js"
import style0 from "./Round.vue?vue&type=style&index=0&id=29c51522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c51522",
  null
  
)

export default component.exports